import React, { useState } from 'react'
import * as api from '../../requests'
import { DialogButton, ConfirmDialog } from '../Modal/Modal'
import { setErrorToast, setSuccessToast } from '../../actions'
import { useDispatch } from 'react-redux'
import Portal from 'components/Portal/Portal'

const RelinquishAccess = ({
  sourceId,
  sourceNum,
  sourceTypeId,
  onRelinquishModalClose,
}) => {    
  const [isShowingConfirm, setIsShowingConfirm] = useState(false)
  const dispatch = useDispatch()

  const confirmRemoveRecordAccess = () => {    
    setIsShowingConfirm(true)         
  }

  const relinquishAccess = () => {
    api.MI_RELINQUISH_RECORD_ACCESS(
      sourceId,
      sourceTypeId,
      (res) => {
        dispatch(setSuccessToast(`Removed from My Records #${sourceNum}`))
        onRelinquishModalClose()
      },
      (err) => {
        dispatch(setErrorToast(err.message))
      }
    )
  }    

  return (
    <div className="manage-access">
      <div className="row">
        <div className="col-12">
          <h2>Remove from My Records</h2>
        </div>
      </div>

      <div className="row">
        <div className="col-12" style={{ padding: '20px 0' }}>
          Would you like to remove this entity, trademark, or insignia from your My Records?           
        </div>
      </div>      
      <div className="row">
        <div className="col-12 button-column" style={{ padding: '20px 0 0' }}>
          <DialogButton
            label="Remove from My Records"
            className="btn-raised"
            customClickHandler
            onClick={confirmRemoveRecordAccess}            
          />
        </div>
      </div>      

      <Portal isOpened={isShowingConfirm}>
        <ConfirmDialog
          closeModal={() => setIsShowingConfirm(false)}
          onModalClosed={() => {}}
          message="Are you sure you want to remove this entity, trademark, or insignia from your My Records?"
          initialFocus=".relinquish-confirm-yes"
          buttons={[
            { label: 'No', onClick: () => {}, className: 'btn-default' },
            {
              label: 'Yes',
              onClick: relinquishAccess,
              className: 'btn-danger relinquish-confirm-yes',
            },
          ]}
          modalStyle={{ borderRadius: 3 }}
        />
      </Portal>
    </div>
  )
}

export default RelinquishAccess
